import AppRoutes from "./AppRoutes";
import DashBoardRoutes from "./DashboardRoutes";
import { Card } from "reactstrap";
import Firebaselogin from "../views/user/login";
import Footer from "../views/nav/Footer";

const LoginRoutes = () => {
  return (
    <>
      {window.localStorage.getItem("user") !== null ? (
        window.localStorage.getItem("profile") == "completed" ? (
          <DashBoardRoutes />
        ) : (
          <AppRoutes />
        )
      ) : (
        <div className="footerbottom">
          <div className="registerpage">
            <Card className="t-card-margin-top">
              <Firebaselogin />
            </Card>
          </div>
          <Footer />
        </div>
      )}
    </>
  );
};
export default LoginRoutes;
